import { ClientSettingsEntity, ClientSettingsUpdateEntity } from '@/entities/client-settings.entity';
import { EndpointOptions } from '@/types/endpoint.options';
import { getAxiosInstance, withSuppressedErrorToast } from '@/client/get-axios-instance';
import { buildMarketplaceApiPath } from '@/repositories/marketplace-api-paths';

class ClientSettingsRepository {
    private readonly _axios = getAxiosInstance(buildMarketplaceApiPath('settings'));

    get(options?: EndpointOptions) {
        return this._axios.get<ClientSettingsEntity>(
            '',
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }

    put(data: ClientSettingsUpdateEntity, options?: EndpointOptions) {
        return this._axios.put<ClientSettingsEntity>(
            '',
            data,
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }
}

export const createClientSettingsRepository = () => new ClientSettingsRepository();

export const clientSettingsRepository = createClientSettingsRepository();
